
// Machine Finder Quiz - Self-contained loader
(function() {
  'use strict';
  
  // Inject CSS
  var style = document.createElement('style');
  style.textContent = `.breadcrumbs-list, .breadcrumbs { display: none !important; }\n  .mf { max-width: 720px; margin: 0 auto; padding: 20px 16px 60px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; -webkit-font-smoothing: antialiased; color: #333; }
  .mf-progress { height: 4px; background: #e9ecef; border-radius: 2px; margin-bottom: 32px; overflow: hidden; }
  .mf-progress__bar { height: 100%; background: #337AB7; border-radius: 2px; transition: width 0.4s ease; }
  .mf-card { text-align: center; padding: 20px 0; }
  .mf-card--intro { max-width: 640px; margin: 0 auto; }
  .mf-card--email { max-width: 520px; margin: 0 auto; }
  .mf-fade-in { animation: mfFadeIn 0.4s ease-out; }
  .mf-fade-in--slow { animation: mfFadeIn 0.5s ease-out; }
  @keyframes mfFadeIn { from { opacity: 0; transform: translateY(12px) scale(0.98); } to { opacity: 1; transform: translateY(0) scale(1); } }
  .mf-title { font-size: 28px; font-weight: 700; color: #1a1a1a; margin-bottom: 12px; line-height: 1.2; }
  .mf-subtitle { font-size: 16px; color: #666; margin-bottom: 32px; line-height: 1.5; }
  .mf-meta { font-size: 13px; color: #999; margin-top: 16px; }
  .mf-step-label { font-size: 13px; color: #337AB7; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 12px; }
  .mf-question { font-size: 22px; font-weight: 600; color: #1a1a1a; margin-bottom: 8px; line-height: 1.3; }
  .mf-question-sub { font-size: 14px; color: #888; margin-bottom: 24px; }
  .mf-answers { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; max-width: 640px; margin: 0 auto; }
  .mf-answers--odd .mf-answer:last-child { grid-column: 1 / -1; max-width: 315px; justify-self: center; }
  .mf-answer { display: block; width: 100%; padding: 16px 20px; background: #f7f9fb; border: 2px solid #e1e8ef; border-radius: 10px; font-size: 16px; font-weight: 500; color: #333; cursor: pointer; transition: all 0.25s ease; text-align: left; -webkit-tap-highlight-color: transparent; }
  .mf-answer:hover { border-color: #337AB7; background: #eef4fb; transform: translateY(-2px); }
  .mf-answer:active, .mf-answer--selected { border-color: #337AB7; background: #337AB7; color: #fff; }
  .mf-back { background: none; border: none; color: #aaa; font-size: 13px; cursor: pointer; padding: 16px 12px 0; text-decoration: none; display: block; margin: 0 auto; }
  .mf-back:hover { color: #666; }
  .mf-btn { display: inline-block; padding: 14px 28px; border: none; border-radius: 8px; font-size: 16px; font-weight: 600; cursor: pointer; text-decoration: none; text-align: center; transition: all 0.2s ease; }
  .mf-btn:hover { transform: translateY(-2px); }
  .mf-btn--primary { background: #337AB7; color: #fff; }
  .mf-btn--primary:hover { background: #2a6496; }
  .mf-btn--lg { font-size: 18px; padding: 16px 40px; }
  .mf-btn--sm { font-size: 14px; padding: 10px 18px; }
  .mf-btn--cart { background: #4caf50; color: #fff; width: 100%; padding: 16px 24px; font-size: 17px; border-radius: 8px; box-sizing: border-box; }
  .mf-btn--cart:hover { background: #43a047; }
  .mf-btn--insurance { background: #337AB7; color: #fff; width: 100%; padding: 14px 24px; font-size: 15px; display: block; border-radius: 8px; box-sizing: border-box; }
  .mf-btn--insurance:hover { background: #2a6496; color: #fff; text-decoration: none; }
  .mf-btn--outline { background: transparent; color: #337AB7; border: 2px solid #337AB7; padding: 12px 24px; }
  .mf-btn--outline:hover { background: #337AB7; color: #fff; }
  .mf-skip { background: none; border: none; color: #aaa; font-size: 13px; cursor: pointer; padding: 12px; text-decoration: underline; display: block; margin: 8px auto 0; }
  .mf-skip:hover { color: #666; }
  .mf-email-form { max-width: 400px; margin: 0 auto; }
  .mf-input { display: block; width: 100%; padding: 14px 16px; font-size: 16px; border: 2px solid #dde2e8; border-radius: 8px; margin-bottom: 12px; outline: none; transition: border-color 0.2s; box-sizing: border-box; font-family: inherit; }
  .mf-input:focus { border-color: #337AB7; }
  .mf-input--sm { padding: 10px 12px; font-size: 14px; margin-bottom: 0; display: inline-block; width: auto; flex: 1; }
  .mf-email-error { color: #dc3545; font-size: 13px; margin-top: 4px; }
  .mf-consent { font-size: 11px; color: #aaa; margin-top: 12px; line-height: 1.4; max-width: 400px; margin-left: auto; margin-right: auto; }
  .mf-consent a { color: #888; }
  .mf-card--loading { padding: 60px 0; }
  .mf-spinner { width: 48px; height: 48px; border: 3px solid #e9ecef; border-top-color: #337AB7; border-radius: 50%; margin: 0 auto 20px; animation: mfSpin 0.7s linear infinite; }
  @keyframes mfSpin { to { transform: rotate(360deg); } }
  .mf-results { max-width: 720px; margin: 0 auto; padding: 0; }
  .mf-result--primary { background: #fff; border: 2px solid #e1e8ef; border-radius: 14px; padding: 24px; margin-bottom: 32px; transition: transform 0.2s; overflow: hidden; }
  .mf-result--primary:hover { transform: translateY(-4px); box-shadow: 0 8px 24px rgba(0,0,0,0.08); }
  .mf-result__badge { display: inline-block; background: #337AB7; color: #fff; font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; padding: 4px 12px; border-radius: 20px; margin-bottom: 20px; }
  .mf-result__layout { display: flex; gap: 24px; align-items: flex-start; text-align: left; }
  .mf-result__image { flex: 0 0 240px; aspect-ratio: 1 / 1; overflow: hidden; border-radius: 10px; background: #f7f9fb; display: flex; align-items: center; justify-content: center; }
  .mf-result__image img { width: 100%; height: 100%; object-fit: contain; border-radius: 10px; }
  .mf-result__info { flex: 1; }
  .mf-result__vendor { font-size: 12px; color: #888; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 4px; }
  .mf-result__name { font-size: 24px; font-weight: 700; color: #1a1a1a; margin: 0 0 4px; }
  .mf-result__name a { color: inherit; text-decoration: none; }
  .mf-result__name a:hover { text-decoration: underline; }
  .mf-result__type { font-size: 14px; color: #666; margin-bottom: 8px; font-weight: 500; }
  .mf-result__match { margin-bottom: 12px; }
  .mf-result__match-label { font-size: 13px; font-weight: 600; color: #337AB7; margin-bottom: 4px; }
  .mf-result__match-bar { height: 8px; background: #e9ecef; border-radius: 4px; overflow: hidden; }
  .mf-result__match-fill { height: 100%; background: linear-gradient(90deg, #337AB7, #60a917); border-radius: 4px; width: 0; transition: width 1s ease-out; }
  .mf-result__match-score { font-size: 12px; color: #888; margin-top: 4px; }
  .mf-result__price { font-size: 20px; font-weight: 700; color: #1a1a1a; margin-bottom: 16px; }
  .mf-result__price-original { text-decoration: line-through; color: #999; font-size: 16px; font-weight: 400; margin-right: 8px; }
  .mf-result__price-discount { color: #60a917; }
  .mf-result__why { background: #f7f9fb; border-radius: 8px; padding: 16px; margin-bottom: 16px; text-align: left; }
  .mf-result__why-label { font-size: 13px; font-weight: 700; color: #337AB7; text-transform: uppercase; letter-spacing: 0.3px; margin-bottom: 8px; }
  .mf-result__why-list { list-style: none; padding: 0; margin: 0; }
  .mf-result__why-list li { font-size: 14px; color: #555; line-height: 1.6; padding: 2px 0 2px 20px; position: relative; }
  .mf-result__why-list li::before { content: '\\2713'; position: absolute; left: 0; color: #60a917; font-weight: 700; }
  .mf-discount { background: #e8f5e9; color: #2e7d32; padding: 12px 16px; border-radius: 8px; font-size: 15px; margin-bottom: 16px; text-align: center; cursor: pointer; position: relative; }
  .mf-discount--gated { background: #fff8e1; color: #333; cursor: default; }
  .mf-discount__prompt { font-size: 14px; font-weight: 600; margin-bottom: 8px; }
  .mf-discount__form { display: flex; gap: 8px; align-items: center; justify-content: center; flex-wrap: wrap; }
  .mf-discount__form .mf-input--sm { min-width: 0; flex: 1 1 200px; box-sizing: border-box; }
  .mf-discount__form .mf-btn--sm { flex-shrink: 0; }
  .mf-result--primary { overflow: visible; }
  .mf-result__info { overflow: visible; min-width: 0; }
  .mf-discount { word-break: break-word; overflow: hidden; box-sizing: border-box; }
  .mf-discount__copied { font-size: 13px; color: #60a917; font-weight: 600; display: none; margin-top: 4px; }
  .mf-result__ctas { display: flex; flex-direction: column; gap: 10px; }
  .mf-also { margin-bottom: 32px; }
  .mf-also__title { font-size: 18px; font-weight: 600; color: #1a1a1a; margin-bottom: 16px; text-align: center; }
  .mf-also__grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; align-items: start; }
  .mf-runner { background: #fff; border: 2px solid #e1e8ef; border-radius: 12px; padding: 16px; text-align: left; transition: transform 0.2s; display: flex; flex-direction: column; overflow: hidden; }
  .mf-runner:hover { transform: translateY(-4px); box-shadow: 0 8px 24px rgba(0,0,0,0.08); }
  .mf-runner__image { aspect-ratio: 1 / 1; overflow: hidden; border-radius: 8px; margin-bottom: 12px; background: #f7f9fb; display: flex; align-items: center; justify-content: center; }
  .mf-runner__image img { width: 100%; height: 100%; object-fit: contain; border-radius: 8px; }
  .mf-runner__vendor { font-size: 11px; color: #888; text-transform: uppercase; letter-spacing: 0.5px; }
  .mf-runner__name { font-size: 16px; font-weight: 600; color: #1a1a1a; margin: 2px 0; }
  .mf-runner__name a { color: inherit; text-decoration: none; }
  .mf-runner__name a:hover { text-decoration: underline; }
  .mf-runner__type { font-size: 12px; color: #666; margin-bottom: 4px; font-weight: 500; }
  .mf-runner__match { margin-bottom: 8px; }
  .mf-runner__match-bar { height: 6px; background: #e9ecef; border-radius: 3px; overflow: hidden; }
  .mf-runner__match-fill { height: 100%; background: linear-gradient(90deg, #337AB7, #60a917); border-radius: 3px; width: 0; transition: width 1s ease-out; }
  .mf-runner__match-score { font-size: 11px; color: #888; margin-top: 3px; }
  .mf-runner__price { font-size: 16px; font-weight: 700; color: #1a1a1a; margin-bottom: 8px; }
  .mf-runner__price-original { text-decoration: line-through; color: #999; font-size: 13px; font-weight: 400; margin-right: 6px; }
  .mf-runner__price-discount { color: #60a917; }
  .mf-runner__why-list { list-style: none; padding: 0; margin: 0; }
  .mf-runner__why-list li { font-size: 13px; color: #555; line-height: 1.5; padding: 1px 0 1px 18px; position: relative; }
  .mf-runner__why-list li::before { content: '\\2713'; position: absolute; left: 0; color: #60a917; font-weight: 700; font-size: 12px; }
  .mf-bottom-cta { text-align: center; padding: 24px; background: #f7f9fb; border-radius: 12px; margin-bottom: 16px; }
  .mf-bottom-cta p { font-size: 15px; color: #666; margin: 0 0 12px; }
  .mf-restart { text-align: center; margin-top: 8px; }
  @media (max-width: 520px) {
    .mf-answers { grid-template-columns: 1fr; }
    .mf-answers--odd .mf-answer:last-child { max-width: none; }
  }
  @media (max-width: 640px) {
    .mf-title { font-size: 24px; }
    .mf-question { font-size: 19px; }
    .mf-result__layout { flex-direction: column; align-items: center; text-align: center; }
    .mf-result__image { flex: 0 0 auto; max-width: 280px; }
    .mf-result__info { text-align: center; }
    .mf-result__why { text-align: left; }
    .mf-also__grid { grid-template-columns: 1fr; }
    .mf-discount__form { flex-direction: column; }
    .mf-input--sm { width: 100%; }
  }
  @media (min-width: 641px) {
    .mf { padding: 32px 24px 80px; }
    .mf-title { font-size: 32px; }
    .mf-question { font-size: 24px; }
    .mf-answer { font-size: 17px; padding: 18px 24px; }
  }`;
  document.head.appendChild(style);
  
  // Find or create the quiz container
  var existingContainer = document.getElementById('machine-finder-quiz');
  if (!existingContainer) {
    // Find the RTE container on the page and inject our div
    var rte = document.querySelector('.rte');
    if (rte) {
      rte.innerHTML = '<div id="machine-finder-quiz" class="mf"></div>';
    } else {
      // Fallback: create at main content
      var main = document.getElementById('MainContent');
      if (main) {
        var div = document.createElement('div');
        div.id = 'machine-finder-quiz';
        div.className = 'mf';
        main.insertBefore(div, main.firstChild);
      }
    }
  }
})();

(function() {
  'use strict';

  /* ── UTM Parsing ── */
  var urlParams = new URLSearchParams(window.location.search);
  var utmData = {
    utm_source: urlParams.get('utm_source') || '',
    utm_medium: urlParams.get('utm_medium') || '',
    utm_campaign: urlParams.get('utm_campaign') || '',
    utm_content: urlParams.get('utm_content') || '',
    utm_term: urlParams.get('utm_term') || ''
  };

  var QUIZ_CONFIG = {
    heading: 'Find Your Perfect CPAP Machine',
    subheading: 'Answer 5 quick questions and we\'ll match you with the ideal machine for your needs.',
    discountCode: 'MYMACHINE',
    discountPercent: 25,
    insuranceUrl: 'https://insurance.easybreathe.com/',
    phoneNumber: '(866) 564-2252',

    questions: [
      {
        id: 'travel_frequency',
        text: 'How often do you travel?',
        subtitle: '',
        answers: [
          { label: 'I travel constantly \u2014 weekly or more',        tags: ['travel-heavy', 'portability-critical'] },
          { label: 'A few trips a year',                          tags: ['travel-occasional'] },
          { label: 'Rarely \u2014 mostly home use',                    tags: ['home-base'] },
          { label: "I'm always on the road (RV, truck, etc.)",    tags: ['travel-heavy', 'portability-critical', 'off-grid'] }
        ]
      },
      {
        id: 'use_location',
        text: 'Where will you mostly use your machine?',
        subtitle: '',
        answers: [
          { label: 'Bedside at home, every night',      tags: ['home-base', 'full-features'] },
          { label: 'Hotels, planes, and trips',         tags: ['travel-heavy', 'portability-critical', 'quiet-priority'] },
          { label: 'Camping, RV, or off-grid',          tags: ['off-grid', 'battery-friendly', 'portability-critical'] },
          { label: 'A mix of home and travel',           tags: ['hybrid-use', 'portability-friendly'] }
        ]
      },
      {
        id: 'therapy_type',
        text: 'Has a doctor prescribed a specific therapy type?',
        subtitle: '',
        answers: [
          { label: 'CPAP (fixed pressure)',                         tags: ['cpap'] },
          { label: 'APAP / Auto-CPAP (adjusts automatically)',     tags: ['apap'] },
          { label: 'BiPAP / BiLevel',                               tags: ['bipap'] },
          { label: "I'm not sure \u2014 I just have a prescription",     tags: ['apap', 'beginner'] },
          { label: "I haven't been prescribed yet",                  tags: ['beginner', 'apap'] }
        ]
      },
      {
        id: 'comfort',
        text: 'What matters most for your comfort?',
        subtitle: '',
        answers: [
          { label: "A quiet machine \u2014 I'm a light sleeper",          tags: ['quiet-priority'] },
          { label: "Built-in humidifier so I don't wake up dry",     tags: ['humidifier'] },
          { label: 'Heated tube to prevent rainout',                  tags: ['heated-tube'] },
          { label: 'Simple \u2014 I just want it to work',                tags: ['simplicity', 'beginner'] }
        ]
      },
      {
        id: 'tech_comfort',
        text: 'How comfortable are you with technology?',
        subtitle: '',
        answers: [
          { label: 'Very \u2014 I want app tracking and data',    tags: ['app-tracking', 'advanced-user'] },
          { label: 'Somewhat \u2014 basic features are fine',     tags: ['simplicity'] },
          { label: 'Not at all \u2014 keep it simple',            tags: ['simplicity', 'beginner'] }
        ]
      }
    ],

    products: [
      { handle: 'airsense-11-autoset-with-humidifier-and-climatelineair-tube', name: 'AirSense 11 AutoSet', type: 'APAP', vendor: 'ResMed', baseScore: 15, price: 134900, image: 'https://cdn.shopify.com/s/files/1/0708/9497/7319/products/airsense-11-autoset-with-humidifier-and-climatelineair-tube-918728.webp?v=1704915266' },
      { handle: 'airsense-10-autoset-with-humidair-and-climatelineair-tube', name: 'AirSense 10 AutoSet', type: 'APAP', vendor: 'ResMed', baseScore: 12, price: 99900, image: 'https://cdn.shopify.com/s/files/1/0708/9497/7319/products/airsense-10-autoset-with-humidair-and-climatelineair-tube-191175.webp?v=1704915265' },
      { handle: 'airmini-autoset-travel-cpap-machine-only', name: 'AirMini AutoSet', type: 'Travel CPAP', vendor: 'ResMed', baseScore: 10, price: 115500, image: 'https://cdn.shopify.com/s/files/1/0708/9497/7319/products/airmini-autoset-travel-cpap-567349.jpg' },
      { handle: 'aircurve-11-vauto-with-humidifier-and-climatelineair-tube', name: 'AirCurve 11 VAuto', type: 'BiPAP', vendor: 'ResMed', baseScore: 8, price: 224900, image: 'https://cdn.shopify.com/s/files/1/0708/9497/7319/files/aircurve-11-vauto-with-humidifier-and-climatelineair-tube-615508.jpg?v=1714800512' }
    ],

    scoring: {
      'travel-heavy':         { machines: ['AirMini AutoSet'], points: 10 },
      'portability-critical':  { machines: ['AirMini AutoSet'], points: 8 },
      'travel-occasional':    { machines: ['AirMini AutoSet', 'AirSense 11 AutoSet', 'AirSense 10 AutoSet'], points: 4 },
      'home-base':            { machines: ['AirSense 11 AutoSet', 'AirSense 10 AutoSet', 'AirCurve 11 VAuto'], points: 6 },
      'hybrid-use':           { machines: ['AirSense 10 AutoSet', 'AirSense 11 AutoSet', 'AirMini AutoSet'], points: 5 },
      'portability-friendly':  { machines: ['AirMini AutoSet', 'AirSense 10 AutoSet'], points: 4 },
      'off-grid':             { machines: ['AirMini AutoSet'], points: 8 },
      'battery-friendly':     { machines: ['AirMini AutoSet', 'AirSense 11 AutoSet', 'AirSense 10 AutoSet'], points: 5 },
      'cpap':   { machines: ['AirSense 11 AutoSet', 'AirSense 10 AutoSet', 'AirMini AutoSet'], points: 10 },
      'apap':   { machines: ['AirSense 11 AutoSet', 'AirSense 10 AutoSet', 'AirMini AutoSet'], points: 10 },
      'bipap':  { machines: ['AirCurve 11 VAuto'], points: 10 },
      'quiet-priority':   { machines: ['AirSense 11 AutoSet', 'AirMini AutoSet'], points: 6 },
      'humidifier':       { machines: ['AirSense 11 AutoSet', 'AirSense 10 AutoSet', 'AirCurve 11 VAuto'], points: 5 },
      'heated-tube':      { machines: ['AirSense 11 AutoSet', 'AirSense 10 AutoSet', 'AirCurve 11 VAuto'], points: 5 },
      'full-features':    { machines: ['AirSense 11 AutoSet', 'AirCurve 11 VAuto'], points: 4 },
      'simplicity':       { machines: ['AirSense 10 AutoSet', 'AirMini AutoSet'], points: 4 },
      'beginner':         { machines: ['AirSense 11 AutoSet', 'AirSense 10 AutoSet'], points: 3 },
      'app-tracking':     { machines: ['AirSense 11 AutoSet', 'AirSense 10 AutoSet', 'AirMini AutoSet'], points: 4 },
      'advanced-user':    { machines: ['AirSense 11 AutoSet', 'AirCurve 11 VAuto'], points: 3 },
      'cpap-neg':          { machines: ['AirCurve 11 VAuto'], points: -15 },
      'apap-neg':          { machines: ['AirCurve 11 VAuto'], points: -15 },
      'bipap-neg':         { machines: ['AirSense 11 AutoSet', 'AirSense 10 AutoSet', 'AirMini AutoSet'], points: -100 },
      'off-grid-neg':      { machines: ['AirCurve 11 VAuto'], points: -5 },
      'travel-heavy-neg':  { machines: ['AirCurve 11 VAuto', 'AirSense 11 AutoSet', 'AirSense 10 AutoSet'], points: -5 }
    },

    phrases: {
      'travel-heavy':         'Built for the road \u2014 TSA-friendly and ultra-portable',
      'portability-critical':  'Compact and lightweight \u2014 fits in any carry-on',
      'travel-occasional':    'Easy to pack for trips when you need it',
      'home-base':            'Designed for nightly home therapy',
      'hybrid-use':           'Works equally well at home and on the road',
      'off-grid':             'Runs on battery \u2014 perfect for camping and RVs',
      'battery-friendly':     'Compatible with portable CPAP batteries',
      'cpap':                 'Delivers reliable fixed-pressure CPAP therapy',
      'apap':                 'Auto-adjusts pressure throughout the night',
      'bipap':                'Delivers two-pressure BiLevel therapy',
      'quiet-priority':       'Whisper-quiet \u2014 won\'t disturb your sleep',
      'humidifier':           'Built-in humidifier prevents dry mouth and throat',
      'heated-tube':          'Heated tube eliminates rainout and condensation',
      'full-features':        'Premium features for the best therapy experience',
      'simplicity':           'Simple controls \u2014 just plug in and breathe',
      'beginner':             'Popular and easy to use \u2014 great for new patients',
      'app-tracking':         'Tracks your therapy in a free companion app',
      'advanced-user':        'Advanced data and settings for power users'
    },

    phrasePriority: [
      'bipap','apap','cpap','travel-heavy','portability-critical','off-grid',
      'quiet-priority','humidifier','heated-tube','battery-friendly','app-tracking',
      'hybrid-use','home-base','full-features','simplicity','beginner',
      'travel-occasional','portability-friendly','advanced-user'
    ],

    fallbacks: {
      'Travel CPAP': ['Ultra-portable design for frequent travelers', 'Trusted by thousands of CPAP users'],
      'APAP':        ['Auto-adjusts pressure as your needs change', 'Trusted by thousands of CPAP users'],
      'CPAP':        ['Reliable fixed-pressure therapy', 'Trusted by thousands of CPAP users'],
      'BiPAP':       ['Two-pressure therapy for complex sleep apnea', 'Trusted by thousands of CPAP users']
    }
  };

  /* ── State ── */
  var state = {
    currentStep: 0,
    answers: [],
    collectedTags: [],
    email: null,
    results: null,
    klaviyoFired: false
  };
  var totalSteps = QUIZ_CONFIG.questions.length + 2;

  /* ── GA4 Tracking ── */
  function trackEvent(name, params) {
    params = params || {};
    if (typeof gtag === 'function') {
      gtag('event', name, params);
    }
  }

  /* ── Klaviyo ── */
  function klaviyoIdentify(email) {
    if (typeof _learnq !== 'undefined') {
      var props = { '$email': email, 'custom_source': 'Machine Finder Quiz' };
      // Set Klaviyo built-in attribution properties from UTM params
      if (utmData.utm_source) props['$source'] = utmData.utm_source;
      if (utmData.utm_medium) props['$medium'] = utmData.utm_medium;
      if (utmData.utm_campaign) props['$campaign'] = utmData.utm_campaign;
      if (utmData.utm_content) props['$content'] = utmData.utm_content;
      if (utmData.utm_term) props['$term'] = utmData.utm_term;
      // Set referrer and landing page
      if (document.referrer) props['$referrer'] = document.referrer;
      props['$first_page'] = window.location.href;
      _learnq.push(['identify', props]);
    }
  }

  function klaviyoSubscribe(email) {
    // Subscribe via Klaviyo client API (same method as mask finder)
    try {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=UVDJsz', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-10-15'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Machine Finder Quiz',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: 'SVGJE6'
                }
              }
            }
          }
        })
      });
    } catch(e) {
      // Fallback to _learnq identify
      if (typeof _learnq !== 'undefined') {
        _learnq.push(['identify', {
          '$email': email,
          '$consent': ['email'],
          'custom_source': 'Machine Finder Quiz'
        }]);
      }
    }
  }

  function klaviyoSetProfileProperties(props) {
    if (typeof _learnq !== 'undefined') {
      _learnq.push(['identify', props]);
    }
  }

  function klaviyoTrack(eventName, properties) {
    if (typeof _learnq !== 'undefined') {
      _learnq.push(['track', eventName, properties]);
    }
  }

  function fireKlaviyoMachineFinderEvent() {
    if (!state.email || state.klaviyoFired || !state.results) return;
    state.klaviyoFired = true;

    var r = state.results;
    var primary = r.primary;
    var ru1 = r.runnerUp1;
    var ru2 = r.runnerUp2;
    var primaryMatch = calculateMatchScore(primary, true);
    var primaryBullets = buildWhyBullets(primary);
    var productUrl = function(handle) { return 'https://easybreathe.com/products/' + handle; };

    // Set custom profile properties
    klaviyoSetProfileProperties({
      '$email': state.email,
      'Machine Finder Recommended': primary.product.name,
      'Machine Finder Type': primary.product.type
    });

    // Build event properties (matching Mask Finder Completed structure)
    var eventProps = {
      recommended_machine: primary.product.name,
      recommended_handle: primary.product.handle,
      recommended_type: primary.product.type,
      recommended_vendor: primary.product.vendor,
      recommended_price: formatDiscountPrice(primary.product.price),
      recommended_original_price: formatPrice(primary.product.price),
      recommended_image: primary.product.image,
      recommended_url: productUrl(primary.product.handle),
      why_text: primaryBullets.join('. '),
      match_score: primaryMatch,
      discount_code: QUIZ_CONFIG.discountCode,
      discount_percent: QUIZ_CONFIG.discountPercent,
      runner_up_1_name: ru1.product.name,
      runner_up_1_handle: ru1.product.handle,
      runner_up_1_type: ru1.product.type,
      runner_up_1_image: ru1.product.image,
      runner_up_1_price: formatDiscountPrice(ru1.product.price),
      runner_up_1_original_price: formatPrice(ru1.product.price),
      runner_up_1_url: productUrl(ru1.product.handle),
      runner_up_2_name: ru2.product.name,
      runner_up_2_handle: ru2.product.handle,
      runner_up_2_type: ru2.product.type,
      runner_up_2_image: ru2.product.image,
      runner_up_2_price: formatDiscountPrice(ru2.product.price),
      runner_up_2_original_price: formatPrice(ru2.product.price),
      runner_up_2_url: productUrl(ru2.product.handle),
      '$event_id': String(Math.floor(Date.now() / 1000))
    };

    // Add UTM data if present
    if (utmData.utm_source) eventProps.utm_source = utmData.utm_source;
    if (utmData.utm_medium) eventProps.utm_medium = utmData.utm_medium;
    if (utmData.utm_campaign) eventProps.utm_campaign = utmData.utm_campaign;
    if (utmData.utm_content) eventProps.utm_content = utmData.utm_content;
    if (utmData.utm_term) eventProps.utm_term = utmData.utm_term;

    klaviyoTrack('Machine Finder Completed', eventProps);
  }

  /* ── Scoring ── */
  function calculateScores() {
    var scores = {};
    QUIZ_CONFIG.products.forEach(function(p) {
      scores[p.name] = { product: p, score: p.baseScore, appliedTags: [] };
    });

    var allTags = state.collectedTags.slice();
    if (allTags.indexOf('cpap') !== -1) allTags.push('cpap-neg');
    if (allTags.indexOf('apap') !== -1) allTags.push('apap-neg');
    if (allTags.indexOf('bipap') !== -1) allTags.push('bipap-neg');
    if (allTags.indexOf('off-grid') !== -1) allTags.push('off-grid-neg');
    if (allTags.indexOf('travel-heavy') !== -1) allTags.push('travel-heavy-neg');

    allTags.forEach(function(tag) {
      var rule = QUIZ_CONFIG.scoring[tag];
      if (!rule) return;
      rule.machines.forEach(function(machineName) {
        if (scores[machineName]) {
          scores[machineName].score += rule.points;
          if (rule.points > 0) scores[machineName].appliedTags.push(tag);
        }
      });
    });

    var sorted = Object.values(scores).sort(function(a, b) {
      if (b.score !== a.score) return b.score - a.score;
      return b.product.baseScore - a.product.baseScore;
    });

    return { primary: sorted[0], runnerUp1: sorted[1], runnerUp2: sorted[2] };
  }

  /* ── Why Bullets ── */
  function buildWhyBullets(result) {
    var tags = result.appliedTags;
    var bullets = [];
    var seen = {};

    QUIZ_CONFIG.phrasePriority.forEach(function(tag) {
      if (tags.indexOf(tag) !== -1 && QUIZ_CONFIG.phrases[tag] && !seen[tag] && bullets.length < 3) {
        bullets.push(QUIZ_CONFIG.phrases[tag]);
        seen[tag] = true;
      }
    });

    if (bullets.length < 2) {
      var fb = QUIZ_CONFIG.fallbacks[result.product.type] || QUIZ_CONFIG.fallbacks['APAP'];
      fb.forEach(function(phrase) {
        if (bullets.length < 2 && bullets.indexOf(phrase) === -1) {
          bullets.push(phrase);
        }
      });
    }

    return bullets;
  }

  /* ── Match Score (cosmetic 80-99%) ── */
  function calculateMatchScore(result, isPrimary) {
    if (isPrimary) {
      return Math.min(99, Math.max(80, 85 + Math.floor(result.score / 3)));
    }
    var primary = state.results.primary;
    var primaryMatch = Math.min(99, Math.max(80, 85 + Math.floor(primary.score / 3)));
    var drop = Math.floor(Math.random() * 6) + 3;
    return Math.max(70, primaryMatch - drop);
  }

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function formatPrice(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function formatDiscountPrice(cents) {
    return formatPrice(Math.round(cents * (1 - QUIZ_CONFIG.discountPercent / 100)));
  }

  function removeQuestionTags(questionIndex) {
    var q = QUIZ_CONFIG.questions[questionIndex];
    var tagsToRemove = {};
    q.answers.forEach(function(a) {
      a.tags.forEach(function(t) { tagsToRemove[t] = true; });
    });
    state.collectedTags = state.collectedTags.filter(function(t) {
      return !tagsToRemove[t];
    });
  }

  /* ── Render ── */
  var root = document.getElementById('machine-finder-quiz');

  function render() {
    if (state.currentStep === 0) renderIntro();
    else if (state.currentStep <= QUIZ_CONFIG.questions.length) renderQuestion(state.currentStep - 1);
    else if (state.currentStep === QUIZ_CONFIG.questions.length + 1) renderEmail();
    else renderResults();
  }

  function renderProgressBar() {
    var progress = state.currentStep / totalSteps * 100;
    return '<div class="mf-progress"><div class="mf-progress__bar" style="width:' + progress + '%"></div></div>';
  }

  function renderIntro() {
    trackEvent('machine_finder_start', { total_questions: QUIZ_CONFIG.questions.length });

    root.innerHTML =
      '<div class="mf-card mf-card--intro mf-fade-in">' +
        '<h1 class="mf-title">' + escapeHtml(QUIZ_CONFIG.heading) + '</h1>' +
        '<p class="mf-subtitle">' + escapeHtml(QUIZ_CONFIG.subheading) + '</p>' +
        '<button class="mf-btn mf-btn--primary mf-btn--lg" data-action="start">Get Started</button>' +
        '<p class="mf-meta">Takes about 30 seconds</p>' +
      '</div>';

    root.querySelector('[data-action="start"]').addEventListener('click', function() {
      state.currentStep = 1;
      render();
    });
  }

  function renderQuestion(qIndex) {
    var q = QUIZ_CONFIG.questions[qIndex];
    var isOdd = q.answers.length % 2 === 1;
    var answersHtml = '';
    q.answers.forEach(function(a, i) {
      answersHtml += '<button class="mf-answer" data-answer="' + i + '"><span>' + escapeHtml(a.label) + '</span></button>';
    });

    var backHtml = '';
    if (qIndex > 0) {
      backHtml = '<button class="mf-back" data-action="back">\u2190 Back</button>';
    }

    root.innerHTML =
      renderProgressBar() +
      '<div class="mf-card mf-fade-in">' +
        '<div class="mf-step-label">Question ' + (qIndex + 1) + ' of ' + QUIZ_CONFIG.questions.length + '</div>' +
        '<h2 class="mf-question">' + escapeHtml(q.text) + '</h2>' +
        (q.subtitle ? '<p class="mf-question-sub">' + escapeHtml(q.subtitle) + '</p>' : '') +
        '<div class="mf-answers' + (isOdd ? ' mf-answers--odd' : '') + '">' + answersHtml + '</div>' +
        backHtml +
      '</div>';

    root.querySelectorAll('.mf-answer').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var idx = parseInt(this.getAttribute('data-answer'));
        var answer = q.answers[idx];

        state.answers[qIndex] = { questionId: q.id, answerIndex: idx, answerText: answer.label, tags: answer.tags };
        answer.tags.forEach(function(t) { state.collectedTags.push(t); });

        this.classList.add('mf-answer--selected');

        trackEvent('machine_finder_answer', {
          question_number: qIndex + 1,
          question_id: q.id,
          answer_text: answer.label,
          questions_remaining: QUIZ_CONFIG.questions.length - (qIndex + 1)
        });

        if (qIndex + 1 === QUIZ_CONFIG.questions.length) {
          trackEvent('machine_finder_complete', { total_questions: QUIZ_CONFIG.questions.length });
        }

        setTimeout(function() { state.currentStep++; render(); }, 350);
      });
    });

    var backBtn = root.querySelector('[data-action="back"]');
    if (backBtn) {
      backBtn.addEventListener('click', function() {
        removeQuestionTags(qIndex - 1);
        state.answers.length = qIndex;
        state.currentStep--;
        render();
      });
    }
  }

  function renderEmail() {
    root.innerHTML =
      renderProgressBar() +
      '<div class="mf-card mf-card--email mf-fade-in">' +
        '<h2 class="mf-question">Where should we send your results?</h2>' +
        '<p class="mf-question-sub">Get your personalized machine recommendation delivered to your inbox, plus exclusive deals and updates.</p>' +
        '<div class="mf-email-form">' +
          '<input type="email" class="mf-input" placeholder="Enter your email" data-email-input />' +
          '<button class="mf-btn mf-btn--primary" data-action="email-submit" style="width:100%">See My Results</button>' +
          '<div class="mf-email-error" data-email-error style="display:none">Please enter a valid email address.</div>' +
        '</div>' +
        '<button class="mf-skip" data-action="email-skip">Skip and see results</button>' +
        '<p class="mf-consent">By entering your email, you agree to receive marketing emails from Easy Breathe. You can unsubscribe at any time. <a href="https://easybreathe.com/policies/privacy-policy" target="_blank">Privacy Policy</a></p>' +
      '</div>';

    root.querySelector('[data-action="email-submit"]').addEventListener('click', function() {
      var input = root.querySelector('[data-email-input]');
      var email = input.value.trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        root.querySelector('[data-email-error]').style.display = 'block';
        input.focus();
        return;
      }
      state.email = email;
      klaviyoIdentify(email);
      klaviyoSubscribe(email);
      trackEvent('machine_finder_email', { email_provided: true });
      state.currentStep++;
      showLoading();
    });

    root.querySelector('[data-action="email-skip"]').addEventListener('click', function() {
      state.email = null;
      trackEvent('machine_finder_email', { email_provided: false });
      state.currentStep++;
      showLoading();
    });

    root.querySelector('[data-email-input]').addEventListener('keydown', function(e) {
      if (e.key === 'Enter') root.querySelector('[data-action="email-submit"]').click();
    });
  }

  function showLoading() {
    root.innerHTML =
      renderProgressBar() +
      '<div class="mf-card mf-card--loading mf-fade-in">' +
        '<div class="mf-spinner"></div>' +
        '<h2 class="mf-question">Finding your perfect machine\u2026</h2>' +
      '</div>';
    state.results = calculateScores();
    setTimeout(renderResults, 1500);
  }

  function renderResults() {
    var r = state.results;
    var primary = r.primary;
    var ru1 = r.runnerUp1;
    var ru2 = r.runnerUp2;

    var primaryMatch = calculateMatchScore(primary, true);
    var ru1Match = calculateMatchScore(ru1, false);
    var ru2Match = calculateMatchScore(ru2, false);

    var primaryBullets = buildWhyBullets(primary);
    var ru1Bullets = buildWhyBullets(ru1);
    var ru2Bullets = buildWhyBullets(ru2);

    // Build discount HTML
    var discountHtml = '';
    if (state.email) {
      discountHtml =
        '<div class="mf-discount" data-action="copy-code">' +
          'Save ' + QUIZ_CONFIG.discountPercent + '% at checkout with code <strong>' + escapeHtml(QUIZ_CONFIG.discountCode) + '</strong>' +
          '<span class="mf-discount__copied" data-copied>Copied!</span>' +
        '</div>';
    } else {
      discountHtml =
        '<div class="mf-discount mf-discount--gated">' +
          '<div class="mf-discount__prompt">Enter your email to unlock your exclusive ' + QUIZ_CONFIG.discountPercent + '% discount</div>' +
          '<div class="mf-discount__form">' +
            '<input type="email" class="mf-input mf-input--sm" placeholder="Enter your email" data-discount-email />' +
            '<button class="mf-btn mf-btn--sm mf-btn--primary" data-action="discount-unlock">Unlock</button>' +
          '</div>' +
        '</div>';
    }

    function priceHtml(product, large) {
      if (state.email) {
        var origClass = large ? 'mf-result__price-original' : 'mf-runner__price-original';
        var discClass = large ? 'mf-result__price-discount' : 'mf-runner__price-discount';
        return '<span class="' + origClass + '">' + formatPrice(product.price) + '</span>' +
               '<span class="' + discClass + '">' + formatDiscountPrice(product.price) + '</span>';
      }
      return formatPrice(product.price);
    }

    function bulletsHtml(bullets, cls) {
      var html = '<ul class="' + cls + '">';
      bullets.forEach(function(b) { html += '<li>' + escapeHtml(b) + '</li>'; });
      html += '</ul>';
      return html;
    }

    var productUrl = function(handle) { return 'https://easybreathe.com/products/' + handle; };

    root.innerHTML =
      '<div class="mf-results mf-fade-in--slow">' +
        '<div class="mf-result mf-result--primary">' +
          '<div class="mf-result__badge">Your Perfect Machine</div>' +
          '<div class="mf-result__layout">' +
            '<div class="mf-result__image"><img src="' + escapeHtml(primary.product.image) + '" alt="' + escapeHtml(primary.product.name) + '" /></div>' +
            '<div class="mf-result__info">' +
              '<div class="mf-result__vendor">' + escapeHtml(primary.product.vendor) + '</div>' +
              '<h2 class="mf-result__name"><a href="' + productUrl(primary.product.handle) + '">' + escapeHtml(primary.product.name) + '</a></h2>' +
              '<div class="mf-result__type">' + escapeHtml(primary.product.type) + '</div>' +
              '<div class="mf-result__match"><div class="mf-result__match-label">' + primaryMatch + '% Match</div><div class="mf-result__match-bar"><div class="mf-result__match-fill" data-match="' + primaryMatch + '"></div></div></div>' +
              '<div class="mf-result__price">' + priceHtml(primary.product, true) + '</div>' +
              '<div class="mf-result__why"><div class="mf-result__why-label">Why This Machine?</div>' + bulletsHtml(primaryBullets, 'mf-result__why-list') + '</div>' +
              discountHtml +
              '<div class="mf-result__ctas">' +
                '<a href="' + productUrl(primary.product.handle) + '" class="mf-btn mf-btn--cart" data-action="add-to-cart" data-handle="' + escapeHtml(primary.product.handle) + '">Add to Cart \u2014 ' + (state.email ? formatDiscountPrice(primary.product.price) : formatPrice(primary.product.price)) + '</a>' +
                '<a href="' + escapeHtml(QUIZ_CONFIG.insuranceUrl) + '" class="mf-btn mf-btn--insurance" data-action="insurance-click" data-machine="' + escapeHtml(primary.product.name) + '">Check Your Insurance Coverage</a>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +

        '<div class="mf-also">' +
          '<h3 class="mf-also__title">Also Great For You</h3>' +
          '<div class="mf-also__grid">' +
            renderRunner(ru1, ru1Match, ru1Bullets) +
            renderRunner(ru2, ru2Match, ru2Bullets) +
          '</div>' +
        '</div>' +

        '<div class="mf-bottom-cta">' +
          '<p>Not sure? Our CPAP specialists can help you choose.</p>' +
          '<a href="tel:+18665642252" class="mf-btn mf-btn--outline">Call ' + escapeHtml(QUIZ_CONFIG.phoneNumber) + '</a>' +
        '</div>' +
        '<div class="mf-restart"><button class="mf-skip" data-action="restart">Retake the quiz</button></div>' +
      '</div>';

    // Animate match bars
    setTimeout(function() {
      root.querySelectorAll('[data-match]').forEach(function(el) {
        el.style.width = el.getAttribute('data-match') + '%';
      });
    }, 100);

    // Copy coupon code
    var couponEl = root.querySelector('[data-action="copy-code"]');
    if (couponEl) {
      couponEl.addEventListener('click', function() {
        if (navigator.clipboard) {
          navigator.clipboard.writeText(QUIZ_CONFIG.discountCode);
        }
        var copied = this.querySelector('[data-copied]');
        if (copied) {
          copied.style.display = 'inline';
          setTimeout(function() { copied.style.display = 'none'; }, 2000);
        }
      });
    }

    // Discount unlock (if no email yet)
    var unlockBtn = root.querySelector('[data-action="discount-unlock"]');
    if (unlockBtn) {
      unlockBtn.addEventListener('click', function() {
        var input = root.querySelector('[data-discount-email]');
        var email = input.value.trim();
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          input.style.borderColor = '#dc3545';
          return;
        }
        state.email = email;
        klaviyoIdentify(email);
        klaviyoSubscribe(email);
        // Fire the Klaviyo event now that we have the email
        fireKlaviyoMachineFinderEvent();
        // Re-render to show discount prices
        renderResults();
      });
    }

    // Add to cart tracking
    root.querySelectorAll('[data-action="add-to-cart"]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        trackEvent('machine_finder_add_to_cart', { product_handle: this.getAttribute('data-handle') });
      });
    });

    // Insurance click tracking
    root.querySelectorAll('[data-action="insurance-click"]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        trackEvent('machine_finder_insurance_click', { recommended_machine: this.getAttribute('data-machine') });
      });
    });

    // Restart
    root.querySelector('[data-action="restart"]').addEventListener('click', function() {
      state.currentStep = 0;
      state.answers = [];
      state.collectedTags = [];
      state.email = null;
      state.results = null;
      state.klaviyoFired = false;
      render();
    });

    // GA4 results event
    trackEvent('machine_finder_results', {
      recommended_machine: primary.product.name,
      recommended_type: primary.product.type,
      recommended_vendor: primary.product.vendor,
      match_score: primaryMatch,
      runner_up_1: ru1.product.name,
      runner_up_2: ru2.product.name
    });

    // Fire Klaviyo event (if email was provided on the email step)
    fireKlaviyoMachineFinderEvent();
  }

  function renderRunner(result, matchScore, bullets) {
    var productUrl = 'https://easybreathe.com/products/' + result.product.handle;

    function priceHtml() {
      if (state.email) {
        return '<span class="mf-runner__price-original">' + formatPrice(result.product.price) + '</span>' +
               '<span class="mf-runner__price-discount">' + formatDiscountPrice(result.product.price) + '</span>';
      }
      return formatPrice(result.product.price);
    }

    return (
      '<div class="mf-runner">' +
        '<div class="mf-runner__image"><img src="' + escapeHtml(result.product.image) + '" alt="' + escapeHtml(result.product.name) + '" /></div>' +
        '<div class="mf-runner__info">' +
          '<div class="mf-runner__vendor">' + escapeHtml(result.product.vendor) + '</div>' +
          '<h4 class="mf-runner__name"><a href="' + productUrl + '">' + escapeHtml(result.product.name) + '</a></h4>' +
          '<div class="mf-runner__type">' + escapeHtml(result.product.type) + '</div>' +
          '<div class="mf-runner__match"><div class="mf-runner__match-bar"><div class="mf-runner__match-fill" data-match="' + matchScore + '"></div></div><div class="mf-runner__match-score">' + matchScore + '% Match</div></div>' +
          '<div class="mf-runner__price">' + priceHtml() + '</div>' +
          '<ul class="mf-runner__why-list">' + bullets.map(function(b) { return '<li>' + escapeHtml(b) + '</li>'; }).join('') + '</ul>' +
          '<a href="' + productUrl + '" class="mf-btn mf-btn--cart mf-btn--sm" data-action="add-to-cart" data-handle="' + escapeHtml(result.product.handle) + '" style="margin-top:12px">Add to Cart</a>' +
        '</div>' +
      '</div>'
    );
  }

  /* ── Init ── */
  render();
})();
